{
  "name": "front-office",
  "version": "1.5.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:cypress": "ng run front-office:serve:e2e",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "aws:deploy": "npm run aws:deploy:dev",
    "aws:deploy:dev": "ng build --configuration dev && sls deploy --stage dev --verbose",
    "aws:deploy:beta": "ng build --configuration beta && sls deploy --stage beta",
    "aws:deploy:prod": "ng build --configuration prod && sls deploy --stage prod",
    "aws:deploy:all": "npm run aws:deploy:dev && npm run aws:deploy:beta && npm run aws:deploy:prod ",
    "lint": "eslint . --ignore-pattern /src/api*/** --ignore-pattern /tests/**/* --ignore-pattern /cypress/**/* --ext .ts",
    "i18n:extract": "ngx-translate-extract --input ./src --output ./src/assets/i18n/{en,pl,fr}.json --format json --sort",
    "i18n:pl": "ngx-translate-extract --input ./src --output ./src/assets/i18n/pl.json --format json --sort",
    "i18n:en": "ngx-translate-extract --input ./src --output ./src/assets/i18n/en.json --format json --sort",
    "test": "ng test",
    "cy:run": "cypress run --headless -- --disable-dev-shm-usage",
    "cy:open": "cypress open",
    "cy:open-no-watch": "cypress open --config watchForFileChanges=false",
    "submodule:up-config": "cd configs && git checkout main && git pull && cd ..",
    "submodule:up-main-api": "cd src/api-main && git checkout main && git pull",
    "submodule:up-auth-api": "cd src/api-auth && git checkout main && git pull",
    "submodule:up-assets": "cd src/assets-common && git checkout main && git pull",
    "submodule:up-invoice-api": "cd src/api-invoice && git checkout main && git pull",
    "up": "npm run submodule:up-config && npm run submodule:up-main-api && npm run submodule:up-auth-api && npm run submodule:up-assets && npm run submodule:up-invoice-api",
    "cy:scheduled": "cypress run --env set=all --headless -- --disable-dev-shm-usage",
    "cy:event": "cypress run --env set=selected --headless -- --disable-dev-shm-usage",
    "storybook": "ng run front-office:storybook",
    "build-storybook": "ng run front-office:build-storybook",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org nsg-e6 --project emu-frontend ./dist",
    "sentry:release": "sentry-cli releases new -p emu-front-office"
  },
  "engines": {
    "node": "^24.21.0",
    "npm": ">10.0.0",
    "yarn": "Please use npm"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.3",
    "@angular/cdk": "^22.1.3",
    "@angular/common": "^22.1.3",
    "@angular/compiler": "^22.1.3",
    "@angular/core": "^22.1.3",
    "@angular/forms": "^22.1.3",
    "@angular/material": "^22.1.3",
    "@angular/material-moment-adapter": "^22.1.3",
    "@angular/platform-browser": "^22.1.3",
    "@angular/platform-browser-dynamic": "^22.1.3",
    "@angular/router": "^22.1.3",
    "@auth0/auth0-angular": "2.2.3",
    "@bluehalo/ngx-leaflet": "^22.0.0",
    "@fontsource/roboto": "^5.0.8",
    "@maskito/angular": "^3.6.0",
    "@maskito/core": "^3.6.0",
    "@maskito/kit": "^3.6.0",
    "@messageformat/core": "^3.4.0",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@sentry/angular": "^11.1.0",
    "@sentry/cli": "^3.8.0",
    "angular-gridster2": "^22.0.0",
    "chart.js": "^4.4.8",
    "chartjs-chart-sankey": "^0.14.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "cypress-real-events": "^1.14.0",
    "dom-to-image": "^2.6.0",
    "get-timezone-offset": "^1.0.5",
    "grapesjs": "^0.22.6",
    "grapesjs-cli": "^4.1.3",
    "grapesjs-plugin-ckeditor": "^1.0.1",
    "jsonpath-plus": "^10.3.0",
    "jspdf": "^4.2.1",
    "juice": "^11.0.1",
    "leaflet": "^1.9.4",
    "leaflet-geosearch": "^4.2.0",
    "material-icons": "^1.13.14",
    "messageformat": "^2.3.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.6.0",
    "ng2-charts": "^8.0.0",
    "ngx-color-picker": "^20.1.1",
    "ngx-cookie": "^6.0.1",
    "ngx-indexed-db": "^22.0.0",
    "ngx-translate-messageformat-compiler": "^7.1.0",
    "p": "^0.2.0",
    "pg": "^8.16.3",
    "rxjs": "7.8.2",
    "tinycolor2": "^1.6.0",
    "tslib": "^2.8.1",
    "uplot": "^1.6.32",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.5",
    "@angular/cli": "~22.1.5",
    "@angular/compiler-cli": "^22.1.3",
    "@angular/localize": "^22.1.3",
    "@compodoc/compodoc": "^1.1.26",
    "@storybook/addon-docs": "10.5.10",
    "@storybook/angular": "10.5.10",
    "@storybook/preset-scss": "^1.0.3",
    "@types/chai": "^5.2.2",
    "@types/google.maps": "^3.55.3",
    "@types/jasmine": "^5.1.2",
    "@types/leaflet": "^1.9.17",
    "@types/mailparser": "^3.4.6",
    "@types/pdfkit": "^0.13.3",
    "angular-eslint": "22.1.0",
    "baseline-browser-mapping": "^2.9.12",
    "css-loader": "^7.1.2",
    "cypress": "^15.12.0",
    "dotenv": "^18.0.3",
    "eslint": "^9.37.0",
    "eslint-config-airbnb-extended": "^2.3.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jasmine": "^4.2.2",
    "eslint-plugin-prettier": "^5.5.4",
    "eslint-plugin-security": "^3.0.1",
    "eslint-plugin-storybook": "10.5.10",
    "fullstack-serverless": "0.8.0",
    "imapflow": "^2.0.6",
    "istanbul-lib-instrument": "^6.0.3",
    "karma": "6.4",
    "karma-chrome-launcher": "3.2",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "5.1",
    "karma-jasmine-html-reporter": "^2.1.0",
    "mailparser": "^3.9.28",
    "prettier": "^3.6.2",
    "resolve-url-loader": "^5.0.0",
    "sass": "^1.89.2",
    "sass-loader": "^16.0.5",
    "serverless": "3.40.0",
    "storybook": "10.5.10",
    "style-loader": "^4.0.0",
    "to-string-loader": "^1.2.0",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.45.0"
  },
  "overrides": {
    "webpack": "5.98.0",
    "ngx-indexed-db": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common"
    }
  }
}
